import { $appearance } from "./appearance/store";
import { $application } from "./application/store";
import { $layout } from "./layout/store";
import { $layoutSource } from "./layout_source/store";
import { $storageObject } from "./storage_object/store";
import { $tenant } from "./tenant/store";
import { $wizard } from "./wizard/store";
import { $wizardInstace } from "./wizard_instance/store";
import { $wizardMask } from "./wizard_mask/store";

/**
 * Main store object
 */
export const $store = {
  applications: $application,
  tenants: $tenant,
  wizardMasks: $wizardMask,
  wizardInstances: $wizardInstace,
  layouts: $layout,
  layoutSources: $layoutSource,
  storageObjects: $storageObject,
  appearance: $appearance,
  wizard: $wizard,
};
